import { useQuery } from "@tanstack/react-query";
import returnsService from "services/admin/returnsService";

export const useGetReturnDetails = (returnID) => {
    return useQuery({
        queryKey: ['getReturnDetails', returnID],
        queryFn: async () => {
            const { data } = await returnsService.get(returnID);
            return data;
        },
        refetchOnWindowFocus: false,
    });
};